import React, { FC, useCallback, useMemo } from 'react';
import { Card } from 'antd';
import {
	getWorkOrderTimeZoneId,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import OWTaskComponent from './OWTaskComponent';
import Meta from 'antd/lib/card/Meta';
import { withUserType } from '../withUserType';
import InlineHyperlink from '../common/InlineHyperlink';

const WOTaskSectionView: FC<any> = ({
	tasks,
	loading,
	extra,
	workOrder,
	isAllowedToEdit = false,
	bulkUpdateTasks = () => {},
	bulkDeleteTasks = () => {},
	onTaskEdit = () => {},
	onTaskDelete = () => {},
	setExistingTasks = () => {},
	userType,
}): React.ReactElement => {
	const taskCount = useMemo(() => {
		const validTasks = tasks.filter((_) => !!nullSafeGetOrElse('title', _, '').trim());
		const completedTasks = validTasks.filter(
			(_) => nullSafeGetOrElse('answer', _, 'false') === 'true'
		);
		return `(${completedTasks.length}/${validTasks.length})`;
	}, [tasks]);

	const allTasksHaveSameWalkthroughLink = useMemo(() => {
		const firstWalkthroughId = nullSafeGet(
			'0.createdFromWalkthroughTaskItem.walkthrough.id',
			tasks
		);
		return tasks.every(
			(_) => nullSafeGet('createdFromWalkthroughTaskItem.walkthrough.id', _) === firstWalkthroughId
		);
	}, [tasks]);

	const walkthroughPath = useMemo(() => {
		const id = nullSafeGet('0.createdFromWalkthroughTaskItem.walkthrough.id', tasks);
		return `/${userType}/siteSurveys/walkthrough/detail/${id}/details`;
	}, [tasks, userType]);

	const walkthroughLink = useMemo(
		() =>
			allTasksHaveSameWalkthroughLink &&
			nullSafeGet('0.createdFromWalkthroughTaskItem.walkthrough.id', tasks) ? (
				<div className="mb-2 flex flex-row items-center gap-2">
					<div>Created from: </div>
					<InlineHyperlink
						path={walkthroughPath}
						text={nullSafeGet('0.createdFromWalkthroughTaskItem.walkthrough.title', tasks)}
					/>
				</div>
			) : null,
		[allTasksHaveSameWalkthroughLink, tasks, walkthroughPath]
	);

	return (
		<Card
			title={
				<div className="flex flex-row items-center">
					<div className="mr-2">Task List</div>
					<div className="mr-2">{taskCount}</div>
				</div>
			}
			loading={loading}
			extra={extra}
		>
			<Meta description={walkthroughLink}></Meta>
			<OWTaskComponent
				existingTasks={tasks}
				isAllowedToEdit={isAllowedToEdit}
				bulkUpdateTasks={bulkUpdateTasks}
				bulkDeleteTasks={bulkDeleteTasks}
				onTaskEdit={onTaskEdit}
				onTaskDelete={onTaskDelete}
				timeZoneId={getWorkOrderTimeZoneId(workOrder)}
				onTasksChange={setExistingTasks}
				workOrder={workOrder}
				hideIndividualWalkthroughLink={allTasksHaveSameWalkthroughLink}
			/>
		</Card>
	);
};

export default withUserType(WOTaskSectionView);
